import {CompanyNewsTileConfig, Deal} from "@irati/types"
import service from "@irati-tracking/tracker"

export interface ClickPerkTrackingData {
  sectionHeader: string
  position: number
  source: string
}

const tracking = {
  // company news
  homePageCreateRowModal: () => {
    service.trackEvent("homepage_open_create_row_modal", {})
  },

  homePageSelectRowSize: (rowType: any) => {
    const params = {
      rowType
    }
    service.trackEvent("homepage_select_row", params)
  },

  homePageRemoveRow: () => {
    service.trackEvent("homepage_remove_modal", {})
  },

  homePageAddNewTileModal: () => {
    service.trackEvent("homepage_add_new_tile_modal", {})
  },

  homePageAddNewTileSubmit: (type: any, tileConfig: CompanyNewsTileConfig, notify_audience?: string) => {
    const source = tileConfig.type === "image" ? "url" : tileConfig.type
    const thumbnail: "image" | "template" = tileConfig.imageUrl ? "image" : "template"

    const params = {
      type,
      source,
      thumbnail,
      notify_audience
    }
    service.trackEvent("homepage_add_new_tile_submit", params)
  },

  homePageAddNewTileChangeTab: (tab: any) => {
    const params = {
      tab
    }
    service.trackEvent("homepage_add_new_tile_change_tab", params)
  },

  homePageDeleteTileModal: () => {
    service.trackEvent("homepage_open_delete_tile_modal", {})
  },

  homePageDeleteTile: () => {
    service.trackEvent("homepage_delete_tile", {})
  },

  homepageView: (data: any) => {
    service.trackEvent("homepage_view", data)
  },

  clickPerk(deal: Deal, trackingData: ClickPerkTrackingData) {
    const {sectionHeader, position, source} = trackingData

    interface LooseObject {
      [key: string]: any
    }

    const data: LooseObject = {
      perk_id: deal.uuid,
      perk_name: deal.header,
      perk_slug: deal.urlSlug,
      perk_category: deal.tagIds,
      perk_type: deal.type,
      deal_provider: deal.provider,
      source,
      lane_name: sectionHeader,
      perk_position: position
    }

    service.trackHomepageEvent("homepage_click_homepage_perk", data)
  },

  startCreateRecognition(source: string) {
    service.trackHomepageEvent("homepage_start_create_recognition", {source})
  },

  clickMyFavourites(product: string, source: string) {
    service.trackEvent("my_favourites_click", {
      product,
      source
    })
  },

  clickOrderHistory(product: string, source: string) {
    service.trackEvent("header_my_perks", {
      product,
      source
    })
  },

  storyStarted: (type: string) => {
    service.trackEvent("start", {
      type,
      product: "story"
    })
  },
  storyViewed: (type: string, detail: number) => {
    service.trackEvent("view", {
      type,
      detail,
      product: "story"
    })
  },
  storyCompleted: (type: string) => {
    service.trackEvent("completed", {
      type,
      product: "story"
    })
  },
  storyDismissed: (type: string, detail: number) => {
    service.trackEvent("dismiss", {
      type,
      detail,
      product: "story"
    })
  },
  storyForward: (type: string, detail: number) => {
    service.trackEvent("forward", {
      type,
      detail,
      product: "story"
    })
  },
  storyBackward: (type: string, detail: number) => {
    service.trackEvent("back", {
      type,
      detail,
      product: "story"
    })
  },
  perksStoryClicked: (type: string, perk_id: string, perk_category: string, perk_name: string, brand: string) => {
    service.trackEvent("cta_click", {
      type,
      perk_id,
      perk_category,
      perk_name,
      brand,
      product: "story"
    })
  },
  celebrationsStoryClicked: (detail: string) => {
    service.trackEvent("cta_click", {
      detail,
      product: "story",
      type: "recogntion"
    })
  }
}

export default tracking
